export const STALE_TIME_5_MIN = 5 * 60 * 1000;
